module.exports = __webpack_public_path__ + "img/redBallone.96990f08.png";